module.exports = __webpack_public_path__ + "img/CON1.a188422e.png";